module.exports = __webpack_public_path__ + "img/start-btn.9445c0b2.svg";